import { useState } from "react";
import { useT } from "../i18n/hooks.ts";
import { Dialog } from "./Dialog.tsx";
import { DialogActions } from "./DialogActions.tsx";

/** Generic "type a name, Save/Cancel" dialog — reused for both renaming the current project and naming its copy. */
export function TextInputDialog({
  title,
  initialValue,
  maxLength,
  onSave,
  onClose,
}: {
  title: string;
  initialValue: string;
  /** Clamps `initialValue` too, not just further typing — a duplicate's suggested name can already exceed it before the user types anything. */
  maxLength?: number;
  onSave: (value: string) => void;
  onClose: () => void;
}) {
  const t = useT();
  const [value, setValue] = useState(maxLength ? initialValue.slice(0, maxLength) : initialValue);
  const trimmed = value.trim();

  function save() {
    if (!trimmed) return;
    onSave(trimmed);
  }

  return (
    <Dialog title={title} onClose={onClose}>
      {/* Dialog's title carries id="dialog-title" and already describes what's being
          typed ("Rename project", "Save copy as"), so it doubles as this field's label. */}
      <input
        type="text"
        value={value}
        aria-labelledby="dialog-title"
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && save()}
        maxLength={maxLength}
        autoFocus
      />
      <DialogActions
        primary={{ label: t("common.save"), onClick: save, disabled: !trimmed }}
        onClose={onClose}
      />
    </Dialog>
  );
}
